const initialState = {
    clientId: undefined,
    collection: [],
    partnerId: undefined,
    scenarioId: undefined,
};

function reducer(state = initialState, action) {
    if (action.type === 'LOGOUT_REQUEST' || action.type === 'AUTHENTICATE_REQUEST') {
        return initialState;
    }

    if (action.type === 'CUSTOMER_ISSUE_APMS_REQUEST') {
        return {
            ...state,
            clientId: action.actionParams.clientId,
            collection: [],
            partnerId: action.actionParams.partnerId,
            scenarioId: action.actionParams.scenarioId,
        };
    }

    if (action.type === 'CUSTOMER_ISSUE_APMS_SUCCESS') {
        return {
            ...state,
            clientId: action.actionParams.clientId,
            collection: action.payload.collection,
            partnerId: action.actionParams.partnerId,
            scenarioId: action.actionParams.scenarioId,
        };
    }

    return state;
}

export default reducer;
